__webpack_require__.p = "https://static.age.awaze.com/landing-pages-mfe/a740d0f/_next/";